module.exports = __webpack_public_path__ + "img/iso27001.7d6f735f.png";